<template>
    <div class="field" :class="{'is-error': isInvalid}">
        <label class="field-label field-label-toggle" :class="{'is-disabled': disabled}" :for="name"><slot name="label">{{label}}</slot></label>
        <input type="checkbox"
               class="field-checkbox"
               :disabled="disabled"
               :id="name"
               :value="value"
               :checked="isChecked" @change="change"/>
        <span class="field-checkbox-style">
            <v-icon :icon="checkIcon"></v-icon>
        </span>
        <span class="field-caption field-caption-toggle" v-if="caption">{{caption}}</span>
    </div>
</template>

<script>
    import shortid from 'shortid';
    import vIcon from './v-icon';

    export default {
        name: 'v-checkbox',
        components: {vIcon},
        model: {
            // here we redefine what property herein
            // the v-model directive should use as the actual `model`
            prop: 'selected',
            // and we tell it to listen for `input` events (see below)
            event: 'input',
        },
        props: {
            label: {
                type: String,
                default: 'Label',
            },
            name: {
                type: String,
                default: () => shortid.generate(),
            },
            caption: {
                type: String,
                default: null,
            },
            selected: { // this is the actual model for the component
                type: [Array, String, Number, Boolean],
            },
            value: {
                type: [String, Boolean],
                default: 'on',
            },
            fuzzy: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            validate: {
                type: Object,
                default: null,
            },
        },
        computed: {
            isInvalid() {
                if (this.validate) {
                    return this.validate.$invalid && this.validate.$dirty;
                }
                return false;
            },
            isChecked() {
                if (this.fuzzy) {
                    return true;
                }
                if (this.selected === null) {
                    return false;
                }
                if (Array.isArray(this.selected)) {
                    return this.selected.includes(this.value);
                }
                return this.selected === this.value;
            },
            checkIcon() {
                if (this.fuzzy) return 'dash-l';
                if (this.isChecked) return 'checkbox-checkmark';
                return '';
            },
        },
        methods: {
            getModelValue() {
                if (!Array.isArray(this.selected)) {
                    return !this.isChecked;
                }

                // copy array to prevent mutation on property
                const copiedModel = this.selected.slice();

                if (this.isChecked) {
                    // uncheck
                    copiedModel.splice(this.selected.indexOf(this.value), 1);
                } else {
                    // check
                    copiedModel.push(this.value);
                }
                return copiedModel;
            },
            change() {
                // we trigger the event (input) we declared in the `model`
                // block above to let the `v-model` directive know
                // the model property is to be mutated in the parent
                // component
                this.$emit('input', this.getModelValue());
            },
        },
    };
</script>
